import React from 'react';

export default function mapProps(mapper, BaseComponent) {
    return function (props) {
        return React.createElement(BaseComponent, mapper(props));
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2-ui/lib/component-helpers/mapProps.js
// module id = 605
// module chunks = 0